/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import BackgroundImage from '../assets/images/background.jpg'
import { LoadingOverlay } from '../components/common'
import { UserContext } from '../stores/UserStore'

const Background = styled.div`
  background: url(${BackgroundImage}) no-repeat center center fixed;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background };
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  font-weight: bold;
`

const Logout = (props) => {
  const history = useHistory()
  const { signOut, applications, app, loadApp } = useContext(UserContext)

  useEffect(() => {
    if (applications) {
      loadApp().then().catch(error => {
        history.replace('/select-app')
      })
    } 
  }, [applications])     


  useEffect(() => {
    if (app) {
      signOut().then(() => {
        if (app.id === 'CLP') {
          window.location.replace(app.link) 
        } else {
          history.replace('/login?app='+app.id)
        }
      }).catch(err => {
        history.replace('/login?app='+app.id)
      })
    } 
  }, [app])

  return (
    <Background>
      <LoadingOverlay visible={true}/>
    </Background>
  )
}

export default Logout